import type { StockControlRow } from '@econtractor/types';
import EmptyResult from 'components/others/EmptyResult';
import StockControlTableRow from './StockControlTableRow';

interface StockControlTableBodyProps {
    rows: StockControlRow[];
    onOpen: (row: StockControlRow) => void;
    showCategory: boolean;
    showArticle: boolean;
}

const StockControlTableBody = ({ rows, onOpen, showCategory, showArticle }: StockControlTableBodyProps) => {
    const colSpan = 2 + (showCategory ? 1 : 0) + (showArticle ? 1 : 0);

    return (
        <tbody>
            {rows.map((row) => (
                <StockControlTableRow
                    key={row.productId}
                    row={row}
                    onOpen={onOpen}
                    showCategory={showCategory}
                    showArticle={showArticle}
                />
            ))}
            {!rows.length && (
                <tr>
                    <td colSpan={colSpan}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default StockControlTableBody;
